var map = {
	"./ADA.svg": 737,
	"./BCH.svg": 738,
	"./BNB.svg": 739,
	"./BTC.svg": 740,
	"./CHZ.svg": 741,
	"./DASH.svg": 742,
	"./DOGE.svg": 743,
	"./DOT.svg": 744,
	"./ETC.svg": 745,
	"./ETH.svg": 746,
	"./EUR.svg": 747,
	"./GBP.svg": 748,
	"./LINK.svg": 749,
	"./LTC.svg": 750,
	"./MATIC.svg": 751,
	"./MKR.svg": 752,
	"./SHIB.svg": 753,
	"./SOL.svg": 754,
	"./TRX.svg": 755,
	"./UNI.svg": 756,
	"./USD.svg": 757,
	"./USDT.svg": 758,
	"./XLM.svg": 759,
	"./XMR.svg": 760,
	"./XRP.svg": 761,
	"./documents.svg": 762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 736;